import { linearTiming } from "@remotion/transitions";
import { TransitionKind, TransitionSpeed } from "@repo/api/transition";
import { msToFrames } from "../../utils/timing.ts";
import {
  getDefaultPreviewClipDurationsInFrames,
  ImageTransitionBuilder,
  ImageTransitionBuilderProps,
} from "./ImageTransitionBuilder.ts";
import { zoomOutBlur, ZoomOutBlurProps } from "../remocn/zoom-out-blur.tsx";

const transitionKind = TransitionKind.enum.ZOOM_OUT_BLUR;

const ZOOM_OUT_BLUR_DURATION_MS: Record<TransitionSpeed, number> = {
  SLOW: 1400,
  NORMAL: 1000,
  FAST: 700,
};

function getZoomOutBlurDurationInFrames(props: ImageTransitionBuilderProps) {
  return msToFrames(
    ZOOM_OUT_BLUR_DURATION_MS[props.imageTransition.speed ?? "NORMAL"],
    props.fps,
  );
}

export const ImageZoomOutBlurTransitionBuilder: ImageTransitionBuilder<ZoomOutBlurProps> =
  {
    formConfig: {
      kind: transitionKind,
      buildDefaultValue: () => ({ kind: transitionKind, speed: "NORMAL" }),
      speed: ["SLOW", "NORMAL", "FAST"],
    },

    transition: {
      getDurationInFrames: getZoomOutBlurDurationInFrames,
      buildPresentation: () => zoomOutBlur(),
      buildTiming: (props) =>
        linearTiming({
          durationInFrames: getZoomOutBlurDurationInFrames(props),
        }),
    },

    getPreviewClipDurationsInFrames: getDefaultPreviewClipDurationsInFrames,
  };
